import React from 'react';

const SectionData = {
  workers: {
    title: 'How it works - Workers',
    content: 'Mint a new Worker, pay the worker\'s contract for the desired day. Each worker can go on an expedition every 24 hours.',
  },
  specialevent: {
    title: 'Special Event',
    content: 'Celebrating our release we are gifting you 1 free day for any new minted worker. Enjoy 🎁',
  },
  spaceships: {
    title: 'How it works - Spaceships',
    content: 'Mint a new Spaceship, each Spaceship has the same amount of workers capacity based on the rarity.',
  },
  mines: {
    title: 'How it works - Mines',
    content: 'Use all your current available Mine Power to go on an expedition. Be aware, farthest planets are more rewarding but the success of the mission will be lower.',
  },
  marketSpacehips: {
    title: 'How it works - Marketplace Spaceship',
    content: 'Buy & Sell Spaceships from other miners. Double check the price. 🕒 MarketPlace is updated every 5 minutes, if you listed a new NFT it will be here soon.',
  },
  marketWorkers: {
    title: 'How it works - Marketplace Workers',
    content: 'Buy & Sell Workers from other miners. Double check the price. 🕒 MarketPlace is updated every 5 minutes, if you listed a new NFT it will be here soon.',
  },
};

export const Information = ({ section, display }) => {
  //console.log('display: ', display);
  const target = SectionData[section];
  return (
    <div className={`alert alert-dark inverse alert-dismissible ${display ? 'show fade' : 'hidden'}`} role='alert'>
      {display ? (
        <>
          <i className={`icon-info-alt`}></i>
          <strong style={{ marginRight: 8 }}>{target.title}: </strong>
          {target.content}
        </>
      ) : undefined}
    </div>
  );
};
